// extracted by mini-css-extract-plugin
export default {"button":"no-purify__overlayToggleButton__button___Ne3FT","label":"no-purify__overlayToggleButton__label___IIc1q"};